import React, {Component} from 'react';
import {connect} from "react-redux";
import withStyles from "@material-ui/core/es/styles/withStyles";
import billingStyles from "./../jss/BillingStyles";
import Table from "@material-ui/core/es/Table";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/es/TableRow";
import TableCell from "@material-ui/core/es/TableCell";
import TableHead from "@material-ui/core/TableHead";
import visibility from '../../../assets/img/visibility-1.png'

class InvoicesTable extends Component {

    render() {
        const { billing: {customer}, handlePaymentDetails, classes } = this.props;
        return (
            <div className={classes.billingContainer}>
                <div className={classes.billingContainerHeader}>
                    <p>Billing Details</p>
                    <button onClick={() => handlePaymentDetails('Add payment Details')} 
                    className={!customer.hasOwnProperty('last4Digits') ? classes.addBtn : classes.editBtn}>
                    </button>
                </div>
                    {!customer.hasOwnProperty('last4Digits') ? 
                    <div className={classes.emptyBillingDetailsContainer}>
                        No payment details added 
                    </div>
                    : 
                    <div className={classes.tableContainer}>
                        <Table>
                            <TableHead>
                                <TableRow className={classes.tableRow}>
                                    {customer.last4Digits && <TableCell className={classes.tableCell}>Card number</TableCell>}
                                    {customer.name && <TableCell className={classes.tableCell}>Name</TableCell>}
                                    {customer.country && <TableCell className={classes.tableCell}>Country</TableCell>}
                                    {customer.region && <TableCell className={classes.tableCell}>State</TableCell>}
                                    {customer.email && <TableCell className={classes.tableCell}>Email</TableCell>}
                                    {customer.city && <TableCell className={classes.tableCell}>City</TableCell>}
                                    {customer.zip && <TableCell className={classes.tableCell}>ZipCode</TableCell>}
                                </TableRow>
                            </TableHead>
                                <TableBody>
                                    <TableRow className={classes.tableRow}>
                                        {customer.last4Digits && <TableCell className={classes.tableCell}>
                                            <img src={visibility} alt="visibility" style={{height: '20px', width: '20px', marginRight: '10px'}} />
                                                {`****-****-****-${customer.last4Digits}`}
                                        </TableCell>}
                                        {customer.name && <TableCell className={classes.tableCell}>{customer.name}</TableCell>}
                                        {customer.country && <TableCell className={classes.tableCell}>{customer.country}</TableCell>}
                                        {customer.region && <TableCell className={classes.tableCell}>{customer.region}</TableCell>}
                                        {customer.email && <TableCell className={classes.tableCell}>{customer.email}</TableCell>}
                                        {customer.city && <TableCell className={classes.tableCell}>{customer.city}</TableCell>}
                                        {customer.zip && <TableCell className={classes.tableCell}>{customer.zip}</TableCell>}
                                    </TableRow>
                            </TableBody>
                        </Table>
                    </div>
                    }
            </div>
        )
    }
}

const mapStateToProps = ({billing}) => ({billing});

export default connect(mapStateToProps, {})(withStyles(billingStyles)(InvoicesTable));


// WEBPACK FOOTER //
// ./src/containers/billing/components/BillingContainer.js